import React, { useState, useEffect } from "react";
import Breadcrumb from "react-bootstrap/esm/Breadcrumb";
import { ProductDetails } from "../../../modals/Product";
import AddToCartForm from "../../AddToCartForm";
import AskQuestion from "../../AskQuestion";
import { isValidImageUrl } from "../../../utils/common";
import { NO_IMG } from "../../../assets/images/images";
import Loader from "../../Loader";
import { generalMessages as MSG } from "../../../utils/constants";
import { GetProductDetailsService } from "../../../services/services";
import SubstituteProducts from "../../SubstituteProducts";

interface ParentProps {
  id: string | number;
  backToList: Function;
}

const HistoryProductDetail: React.FC<ParentProps> = ({ id, backToList }) => {
  const [product, setProduct] = useState<ProductDetails>();
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      getProjectDetails(id);
    }
  }, [id]);

  const getProjectDetails = async (id: string | number) => {
    const result = await GetProductDetailsService(id.toString());
    if (result.data.flag && result.data.data.length !== 0) {
      setProduct(result.data.data);
    } else {
      setStatus(MSG.PRODUCT_NOT_FOUND);
    }
  };

  return (
    <div>
      <div className="product-wrapper">
        <section className="product-details">
          <div className="container-xl">
            <Breadcrumb className="primary-breadcrumb">
              <Breadcrumb.Item onClick={() => backToList()}>
                <span className="text-truncate">History products</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                <span className="text-truncate">{product?.name}</span>
              </Breadcrumb.Item>
            </Breadcrumb>

            {status ? (
              status
            ) : product ? (
              <div className="row">
                <div className="col-md-auto">
                  <div className="product-img">
                    <i>
                      <img
                        onError={() =>
                          setProduct({ ...product, product_image: NO_IMG })
                        }
                        src={
                          isValidImageUrl(product.product_image)
                            ? product.product_image
                            : NO_IMG
                        }
                        alt={product.product_image}
                      />
                    </i>
                  </div>
                </div>
                <div className="col-md">
                  <div className="product-micro-detail">
                    {product.product_model && (
                      <span className="product-model">
                        Product Code: {product.product_model}
                      </span>
                    )}
                    <h4 className="product-name">{product.name}</h4>
                    {product.allergen_images.length > 0 && (
                      <div className="d-flex align-items-center flex-wrap mb-3 gap-1">
                        {product.allergen_images.map((icon, index) => ( 
                            <img
                              key={index}
                              src={icon}
                              alt={`allergen-${index}`}
                              onError={(e) => (e.currentTarget.src = NO_IMG)}
                              className="img-fluid rounded mr-2"
                              style={{ width: "30px", height: "30px", objectFit: "contain" }}
                            />
                          )
                        )}
                      </div>
                    )}
                    <div className="d-flex">
                      <span className="price">$ {product.price} {(product.name.toLowerCase().startsWith("rw") || product.description.toLowerCase().startsWith("rw")) && "/ 1 Kg"}</span>
                      {product.rw_price && <span className="rw_price ml-4">est. ${product.rw_price} Pack</span>}
                    </div>
                    {product.out_of_stock ? (
                      <div className="out-of-stock">
                        {product.out_of_stock ? "OUT OF STOCK" : ""}
                        <SubstituteProducts id={product.id} />
                      </div>
                    ) : (
                      ""
                    )}
                    <AddToCartForm {...product} />
                    <AskQuestion {...product} />
                    {product.is_cut_off_time_completed && <p className="cutoff-time-message">Today's order cutoff has passed, earliest delivery time is the day after tomorrow</p>}
                    <div className="product-description">
                      <h6>Product Brand</h6>
                      <p>{product.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default HistoryProductDetail;
